var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.996,
    height: 22.531,
    viewBox: "0 0 31.996 22.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55978",
    transform: "translate(-1029.936 -636.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    width: 31.996,
    height: 22.531,
    rx: 2,
    transform: "translate(1029.936 636.441)",
    fill: "#36495d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(1035.994 641.564)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    width: 5.375,
    height: 9.66,
    transform: "translate(7.252 1.314)",
    fill: "#f16522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M1098.595,694.218a6.133,6.133,0,0,1,2.346-4.83,6.143,6.143,0,1,0,0,9.659,6.133,6.133,0,0,1-2.346-4.83",
    transform: "translate(-1091.002 -688.075)",
    fill: "#e41b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M1201.136,694.218a6.143,6.143,0,0,1-9.939,4.83,6.144,6.144,0,0,0,0-9.66,6.143,6.143,0,0,1,9.939,4.83m-.586,3.807v-.2h.08v-.04h-.2v.04h.08v.2Zm.394,0v-.238h-.062l-.071.164-.072-.164h-.062v.238h.044v-.18l.067.155h.046l.067-.156v.18Z",
    transform: "translate(-1181.257 -688.075)",
    fill: "#f89e1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardCard);
export default __webpack_public_path__ + "static/media/mastercard-card.dc8360ade4485e411cebcb804a85c4ae.svg";
export { ForwardRef as ReactComponent };